import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic/currency';
import { percentageInput } from '@/_schemas/generic/percentage';

import { commissionEarningModelFormSchema } from './commission-earning-model-schema';
import { commissionPlansQuerySchema } from './commission-plans-query-schema';
import { commissionTiersFormSchema } from './commission-tiers';

const validatePercentage = (val: string | null | undefined) => {
  if (val === null || typeof val === 'undefined') return false;
  const num = parseFloat(val);
  return num >= 0 && num <= 100;
};

export const commissionPlansFormSchema = commissionPlansQuerySchema.extend({
  name: z.string().min(1, 'Name is required'),
  base_quota_amount: currencyInput.formSchema().refine((v) => {
    if (v === null || typeof v === 'undefined') return false;
    return parseFloat(v) >= 0;
  }, 'Base quota amount must be greater than or equal to 0'),
  default_one_time_rate: percentageInput.formSchema().refine(validatePercentage, 'Default one-time rate is required'),
  default_recurring_rate: percentageInput.formSchema().refine(validatePercentage, 'Default recurring rate is required'),
  bonus_amount: currencyInput.formSchema(),
  bonus_threshold: currencyInput.formSchema(),
  commission_tiers: z.array(commissionTiersFormSchema),
  commission_earning_model: commissionEarningModelFormSchema,
});

export type CommissionPlansFormSchema = z.infer<typeof commissionPlansFormSchema>;
